import { AlertTriangle, Instagram, Youtube, Phone } from "lucide-react";

export default function Maintenance() {
    return (
        <div className="min-h-screen bg-paper text-ink flex items-center justify-center relative overflow-hidden" data-testid="maintenance-page">
            {/* Subtle background — reuse one of the AI-generated cinematic images at low opacity */}
            <div className="absolute inset-0 opacity-15">
                <img src="/generated/hero.jpg" alt="" className="w-full h-full object-cover object-[45%_55%] md:object-center" />
            </div>
            <div className="absolute inset-0 grain opacity-40 pointer-events-none" />

            <div className="relative container-editorial max-w-2xl text-center py-24">
                {/* Fault sign */}
                <div className="inline-flex items-center justify-center w-24 h-24 rounded-full border-2 border-gold text-gold mb-10" data-testid="maintenance-fault-sign">
                    <AlertTriangle size={40} strokeWidth={1.5} />
                </div>

                <div className="overlabel text-earth mb-6" data-testid="maintenance-brand">Omkar Dairy Farm</div>

                <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight mb-8" data-testid="maintenance-heading">
                    Under<br />Construction
                </h1>

                <p className="text-ink/70 text-lg leading-relaxed max-w-md mx-auto mb-12" data-testid="maintenance-subtext">
                    We&apos;re polishing a few last things before opening the farm gate. Please come back shortly.
                </p>

                <div className="border-t border-border pt-8 flex flex-wrap items-center justify-center gap-6 md:gap-10 text-ink/75">
                    <a href="tel:+919151515975" className="inline-flex items-center gap-2 text-sm link-underline" data-testid="maintenance-phone">
                        <Phone size={14} strokeWidth={1.5} className="text-forest" /> +91 91515 15975
                    </a>
                    <a href="https://www.instagram.com/omkardiaryfarm" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm link-underline" data-testid="maintenance-instagram">
                        <Instagram size={14} strokeWidth={1.5} className="text-forest" /> @omkardiaryfarm
                    </a>
                    <a href="https://www.youtube.com/results?search_query=omkardiaryfarm" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm link-underline" data-testid="maintenance-youtube">
                        <Youtube size={14} strokeWidth={1.5} className="text-forest" /> @omkardiaryfarm
                    </a>
                </div>

                <div className="mt-16 text-xs text-mist tracking-widest uppercase">
                    HN Kaval · Nagamangala · Mandya · Karnataka
                </div>
            </div>
        </div>
    );
}
